import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import TopAppBar from './TopAppBar';
import Drawer from './Drawer';
import { useRecoilValue } from 'recoil';
import { userState } from '../../state/RecoilState';
import Toast from '../Common/Toast';

const Layout: React.FC = () => {
  const [open, setOpen] = useState(true);
  const user = useRecoilValue<any>(userState);
  const isLoggedIn = !!user;
  const isAdmin = user?.role === 'Administrator';

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {isLoggedIn && <TopAppBar toggleDrawer={toggleDrawer} open={open} />}
      {isAdmin && <Drawer toggleDrawer={toggleDrawer} open={open} />}

      <Box
        sx={{ mt: '64px', width: '100%', px: 2, pt: 2 }}
        className='main-content'
      >
        <Outlet />
      </Box>
      <Toast />
    </Box>
  );
};

export default Layout;
